import type { FPost, WithCreatorData } from 'garden-common';
import { writable } from 'svelte/store';

// Posts
export type Tab = 'Details' | 'Workflow' | 'Tags' | 'Comments' | 'Seeds';

export const tabList: Tab[] = ['Details', 'Workflow', 'Tags', 'Comments', 'Seeds'];
export const openPostInModal = writable<boolean>(false);
export const postModalTabs = writable<Tab>('Details');
export const postIdInModal = writable<string>();

export const searchOpen = writable<boolean>(false);

export const postInModal = writable<{
  post: Partial<FPost<string>> & Partial<WithCreatorData>;
  isLoading: boolean;
}>();

export const openPostDetailsModal = writable<boolean>(true);
export const postinDetailsModal = writable<Partial<FPost<string>> & Partial<WithCreatorData>>();
export const selectedPostDetailsTab = writable<'likes' | 'seeds' | 'saves'>('likes');
